import {skipToken} from '@reduxjs/toolkit/query';

import {useLanesForDocument} from 'app/lanes/api';
import {useProcedureById} from 'app/procedures/api';
import {useProcessById} from 'app/process/api';

import type {TaskAssignableContentTypes} from 'sweet-types';

export function useDocumentLoader(
  doc: null | {
    contentType: TaskAssignableContentTypes;
    objectId: number;
  }
) {
  const procedure = useProcedureById(doc?.objectId ?? skipToken, {
    skip: doc?.contentType !== 'procedure',
    refetchOnMountOrArgChange: 10,
  });

  const process = useProcessById(doc?.objectId ?? skipToken, {
    skip: doc?.contentType !== 'proceduregroup',
    refetchOnMountOrArgChange: 10,
  });

  const {isFetching: isFetchingLanes, currentData: lanes} = useLanesForDocument(
    doc == null
      ? skipToken
      : {object_ids: doc.objectId, content_type: doc.contentType}
  );

  return doc?.contentType === null
    ? {
        data: undefined,
        currentData: undefined,
        isFetching: false,
        isLoading: false,
        error: undefined,
        refetch: () => undefined,
      }
    : doc?.contentType === 'procedure'
    ? {
        ...procedure,
        currentData: lanes && procedure.currentData,
        isFetching: procedure.isFetching || isFetchingLanes,
      }
    : {
        ...process,
        currentData: lanes && process.currentData,
        isFetching: process.isFetching || isFetchingLanes,
      };
}
